module.exports = __webpack_public_path__ + "img/turquoise.75e4b53.webp";